import axiosService from './common/axios'

// function searchMainStatBoardData (paramData) {
//   return axiosService.get('main/statBoard', { params: paramData })
// }

function searchChartData (paramData) {
	return axiosService.get('notice/boards/selectChartData', { params: paramData })
}

// function searchMainChartNameData (paramData) {
// 	return axiosService.get('notice/boards//selectMainChartNameData', { params: paramData })
// }

function searchChartTitleData (paramData) {
	return axiosService.get('notice/boards/selectChartTitleData', { params: paramData })
}

export { searchChartData, searchChartTitleData }
